import moment from "moment";
import { JOMS_API_BASE_V1_URL } from "constants";

const FT_TIMESTAMP_FORMAT = "DD-MMM-YYYY hh:mm A";
const EMPTY_EVENTS = [];

// Relative path: host is supplied by the axios instance baseURL
export const getFtStatusHistoryUrl = (orderNumber) =>
  `${JOMS_API_BASE_V1_URL}/v1/orders/${orderNumber}/shipments/ft-status-history`;

const formatFtTimestamp = (value) =>
  value && moment(value).isValid()
    ? moment(value).format(FT_TIMESTAMP_FORMAT)
    : "-";

export const FT_STATUS_HISTORY_COLUMNS = [
  { key: "ftStatus", label: "STATUS" },
  {
    key: "ftEventTimestamp",
    label: "FT Event Timestamp",
    format: formatFtTimestamp,
  },
  {
    key: "omsReceivedTimestamp",
    label: "OMS Received Timestamp",
    format: formatFtTimestamp,
  },
];

// { [shipmentId]: events[] } for O(1) lookup per shipment
export const buildFtStatusHistoryMap = (shipments = []) =>
  shipments.reduce((acc, { shipmentId, events }) => {
    if (shipmentId) acc[shipmentId] = events ?? EMPTY_EVENTS;
    return acc;
  }, {});

export const getFtStatusEvents = (historyMap, shipmentNumber) =>
  historyMap?.[shipmentNumber] ?? EMPTY_EVENTS;
